import { User } from './../models/user';
import { Header } from 'primeng/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class TechnicianService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  technicianData: any;
  technicianTaskData: any;
  technicianId: any = '';
  techImage: string = '';
  technicianID: any;
  groupPlantData: any;
  From: any;
  To: any;
  technicianTabIndex = 0;
  TechnicianHeaderData: any = { Group: '', Plant: '', FromDate: '', ToDate: '' }
  TechnicianSkillMatrixHeaderData: any = { Group: '', Plant: '' }
  private woDataSubject = new BehaviorSubject<any>(null);
  unit: any = '';

  constructor(private http: HttpClient) { }

  setTechnicianTabIndex(index: number): void {
    this.technicianTabIndex = index;
  }

  getWObject(): Observable<any> {
    return this.woDataSubject.asObservable();
  }

  getTechnicianTabIndex() {
    return this.technicianTabIndex;
  }


  setTechnicianHeaderData(data: any) {
    this.TechnicianHeaderData.Group = data.Group
    this.TechnicianHeaderData.Plant = data.Plant
    this.TechnicianHeaderData.FromDate = data.FromDate
    this.TechnicianHeaderData.ToDate = data.ToDate
  }
  getTechnicianHeaderData() {
    return this.TechnicianHeaderData;
  }

  setSkillMatrixHeaderData(data: any) {
    this.TechnicianSkillMatrixHeaderData.Group = data.Group
    this.TechnicianSkillMatrixHeaderData.Plant = data.Plant
  }
  getSkillMatrixHeaderData() {
    return this.TechnicianSkillMatrixHeaderData;
  }

  setFromDate(date: any) {
    this.From = date;
  }

  getFromDate() {
    return this.From;
  }

  setToDate(date: any) {
    this.To = date;
  }

  getToDate() {
    return this.To;
  }

  // setTechnicianValues(element: any) {
  //   this.technicianData = element
  // }

  setTechnicianValues(data: any): void {
    this.technicianData = data;
    this.woDataSubject.next(data); // Update WO object
  }

  getTechnicianValues() {
    return this.technicianData
  }

  setTechnicianTaskValues(element: any) {
    this.technicianTaskData = element
  }

  getTechnicianTaskValues() {
    return this.technicianTaskData
  }

  setTechnicianId(technicianId: number) {
    this.technicianId = technicianId;
  }

  setSelTech(technicianID: number) {
    this.technicianID = technicianID;
  }

  getSelTech() {
    return this.technicianID;
  }

  getTechnicianId() {
    return this.technicianId;
  }

  setTechnicianImage(techImage: string) {
    this.techImage = techImage;
  }

  getTechnicianImage() {
    return this.techImage;
  }

  setGroupPlant(GroupPlant: any) {
    this.groupPlantData = GroupPlant;
  }

  getGroupPlant() {
    return this.groupPlantData
  }

  getTechnicianList(headerData: any) {
    // return this.http.get<any>(this.baseUrl + 'getTechnicianList', { params: headerData });
    return this.http.get<any>(this.O3CoreApiUrl + 'TechScore/getTechnicianList', { params: headerData });
  }

  // getTechnisionHistory(UserId: any) {
  //   return this.http.get<any>(this.baseUrl + 'getTechnisionHistory', { params: { UserId: UserId } });
  // }

  //NOT IN USE
  // getTechnisionHistoryTask() {
  //   return this.http.get<any>(this.baseUrl + 'getTechnisionHistoryTask');
  // }

  getTechnicianExecutionList(data: any): Observable<any[]> {
    return this.http.get<any>(this.O3CoreApiUrl + 'PMTechnicianExecution/showTechExecWO', { params: data });
  }

  addTechnician(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-technician-execution', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'PMTechnicianExecution/addTechExecWO', data);
  }

  updateTechnician(data: any): Observable<any[]> {
    // return this.http.put<any>(this.baseUrl + 'update-technician-execution', data);
    return this.http.put<any>(this.O3CoreApiUrl + 'PMTechnicianExecution/updateTechExecWo', data);
  }

  getTechnician(data: any): Observable<any[]> {
    return this.http.get<any>(this.O3CoreApiUrl + 'PMTechnicianExecution/showTechExecWO', { params: { WOId: data } });
  }

  getAssignedTechnicians(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'PMTechnician/getTechnicianAssigned', data);
  }

  GetSubTaskWorkOrdersByTaskOrWOID(data: any): Observable<any[]> {
    let httpParams = new HttpParams();

    if (data.technicianTaskId !== undefined) {
      httpParams = httpParams.set('technicianTaskId', data.technicianTaskId);
    }
    if (data.WOId !== undefined) {
      httpParams = httpParams.set('WOId', data.WOId);
    }

    if (data.technicianExecutionWOID !== undefined) {
      httpParams = httpParams.set('technicianExecutionWOID', data.technicianExecutionWOID);
    }

    if (data.responsibleId !== undefined) {
      httpParams = httpParams.set('responsibleId', data.responsibleId);
    }

    if (data.isAssignedToMainTask !== undefined) {
      httpParams = httpParams.set('isAssignedToMainTask', data.isAssignedToMainTask);
    }

    return this.http.get<any[]>(this.O3CoreApiUrl + 'PMSubTaskWorkOrder/GetSubTaskWorkOrdersByTaskOrWOID', {
      params: httpParams
    });
  }
  assignTechnician(payload: any): Observable<any> {
    const url = `${this.O3CoreApiUrl}PMTechnicianExecution/AssignNewTechExecWO`;
    return this.http.post(url, payload);
  }
  getChecklistByGroupsAndTaskId(taskId: number, technicianTaskId: number): Observable<any> {
    return this.http.get(`${this.O3CoreApiUrl}PMQualityChecklist/GetChecklistWithExecutionByTaskId`, {
      params: {
        id: taskId,
        techId: technicianTaskId
      }
    });
  }

  addChecklistExecutionsJson(data: any): Observable<any> {
    return this.http.post(`${this.O3CoreApiUrl}PMQualityChecklist/AddChecklistExecutions`, data);
  }

  updateChecklistExecutionsJson(data: any): Observable<any> {
    return this.http.post(`${this.O3CoreApiUrl}PMQualityChecklist/UpdateChecklistExecutions`, data);
  }
  getTechnicianTaskParametertargetBytechnicianId(technicianTaskId: number): Observable<any> {
    return this.http.get(`${this.O3CoreApiUrl}PMTechnicianTaskParameterTarget/GetTechnicianTaskParameterTargetByTaskId?technicianTaskId=${technicianTaskId}`);
  }
}
